import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { ChooseImageComponent, FunctionService, LanguageService, ManageLibraryComponent } from 'vhobjects-service';

@Component({
  selector: 'atw-image-detail-repeat-admin',
  templateUrl: './image-detail-repeat-admin.component.html',
  styleUrls: ['./image-detail-repeat-admin.component.scss']
})
export class AtwImageDetailRepeatAdmin implements OnInit {
  @Input() isSharedImg: boolean;
  @Input() device: string;
  @Input() data: any;
  @Input() dimension: any;
  @Input() dataRow: any;
  @Input() itemEdit: any;
  @Input() sourceImg: string;
  @Input() sources: any[];
  @Input() compressType: string = 'compress-frame';
  @Input() compressWidth: number = 100;
  @Input() compressHeight: number = 100;
  @Input() arr_link_page: any;

  /** Lấy reference đến thẻ bao quanh danh sách ảnh */
  @ViewChild('scrollList') scrollList!: ElementRef;

  dataImages: any = [];
  dataLoaded: boolean;
  tabChoosing: any = {}; // Biến dùng để lưu tab đang được chọn
  resolution = null;
  path = '';
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  id_subproject: any;
  subproject = null;
  toggleInputLinkImg: boolean = false;
  newUrlImage: string = '';
  iconAddImage = {
    device: 'vertical_align_top',
    library: 'image',
    url: 'link',
    free_img: 'cloud_upload',
  };
  type_link: any = [
    { value: 'none', label: 'khong' },
    { value: 'page_link', label: 'den_trang' },
    { value: 'navigation_link', label: 'lien_ket_dieu_huong' },
    { value: 'hyper_link', label: 'lien_ket_trang_khac' },
    { value: 'mailto', label: 'Email' }, 
    { value: 'tel', label: 'so_dien_thoai' }
  ];
  clickActionOptions:any = [
    {
      value: true, label: 'cuon_len_dau_trang'
    },
    {
      value: false, label: 'giu_nguyen_vi_tri'
    },
    {
      value: 'scroll_to_block', label: 'cuon_den_khoi'
    }
  ]
  blocks_of_page?: any = [];
  previewUrl: string | null = null;
  dragging = false;
  isOpenGuideVideo = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalRef: NzModalRef<AtwImageDetailRepeatAdmin>,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private matDialog: MatDialog,
    public functionService: FunctionService,
    private languageService: LanguageService,
    private vhImage: VhImage,
  ) { }

  ngOnInit(): void {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(this.id_subproject);
    this.resolution = this.subproject.resolution;

    this.getData();

    // Cập nhật cấu hình để xử lý khi click ra ngoài (hoặc bấm nút X)
    this.modalRef.updateConfig({
      nzOnCancel: () => {
        this.close(); // Gọi hàm close của bạn để trả về result
        return false; // Quan trọng: return false để chặn việc đóng mặc định (để hàm this.close() của bạn toàn quyền xử lý)
      }
    });
  }

  /**
   * Lấy data để thực hiện kéo thả và load danh sách hình ảnh
   * @returns
   */
  getData() {
    if (this.dataLoaded) return; // Nếu dữ liệu đã được tải, không gọi API nữa
    // this.item
    this.updateDataImgs();
    this.dataLoaded = true;
  }

  /**
   * Hàm thực hiện việc thay đổi vị trí của các hình ảnh trong danh sách
   * @param event
   */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    // moveItemInArray(this.dataImages, event.previousIndex, event.currentIndex);
    const arr = [...this.dataImages];
    const item = arr.splice(event.previousIndex, 1)[0];
    arr.splice(event.currentIndex, 0, item);
    this.dataImages = arr;

    if (this.isSharedImg) {
      this.functionService.devices.forEach((device) => {
        this.itemEdit[device.value + '_value'] = this.dataImages;
      });
    } else {
      this.itemEdit[this.device + '_value'] = this.dataImages;
    }

    // this.updateData(this.dataRow);
  }

  /**
   * Xoá hình ảnh với vị trí truyền vào
   * @param index vị trí hình ảnh trong danh sách
   */
  removeImage(index: number) {
    if (this.isSharedImg) {
      this.functionService.devices.forEach((device) => {
        this.itemEdit[device.value + '_value'].splice(index, 1);
      });
    } else {
      this.itemEdit[this.device + '_value'].splice(index, 1);
    }

    this.updateDataImgs();

    // this.updateData(this.dataRow); // Gọi lại sau khi xoá
  }

  /**
   * Thêm hình ảnh mới
   */
  addImage() {
    switch (this.sourceImg) {
      case 'device':
        this.openUpload();
        break;
      case 'library':
        this.openLibrary();
        break;
      case 'url':
        this.toggleInputLinkImg = true;
        break;
      case 'free_img':
        this.openDialogChooseImage();
        break;
    }
    // // this.updateData(this.dataRow); // Gọi lại sau khi thêm
  }

  /**
   * Thay đổi loại hình ảnh: dùng chung ảnh cho các thiet bi, dùng rieng ảnh cho tung thiet bi
   */
  changeImgType() {
    // nếu đối imgType thành dùng chung ảnh cho từng thiết bị thì lưu ảnh của thiết bị có width lớn nhất vào các thiết bị còn lại
    if (this.isSharedImg) {
      this.functionService.devices.forEach((device) => {
        this.itemEdit[device.value + '_value'] =
          this.itemEdit[this.device + '_value'];
      });
    }
    // this.updateData(this.dataRow);
  }

  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId))
      document.getElementById('upload').click();
    // inputVal;
  }
  /**
   * Hành động tải tệp lên
   */
  onUpload(e) {
    const file = e.target.files[0];
    const input = e.target as HTMLInputElement;

    if (file && file.type.startsWith('image/')) {
      this.processImageUpload(file);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_chon_tep_hinh_anh_hop_le');
        return;
      }
    }

    // Đặt lại giá trị của trường tệp để kích hoạt sự kiện change lần sau
    input.value = '';
  }

  /**
   * Hàm xử lý khi người dùng kéo và thả (drop) một tệp vào vùng upload.
   * @param event
   */
  onFileDropped_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];

    if (file && file.type.startsWith('image/')) {
      // Hiển thị preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Xử lý tệp hình ảnh
      this.processImageUpload(file);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
   * Hành động khi người dùng kéo file qua vùng upload (chưa thả).
   * @param event 
   */
  onDragOver_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  /**
   * Hành động khi người dùng rời con trỏ khỏi vùng upload mà chưa thả.
   */
  onDragLeave_upload() {
    this.dragging = false;
  }

  /**
   * Hàm xử lý tệp hình ảnh lên server 
   * - Tải lên
   * - Kéo thả vào
   * 
   * Nén ảnh:
   * - 'no-compress': Không nén ảnh sau khi tải lên
   * - 'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
   * - 'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
   * @param file File được kéo thả vào hoặc được tải lên
   */
  processImageUpload(file: File) {
    let compress_type = this.compressType;
  
    let resolution = {};
    switch (compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.dimension[this.device];
        if (
          dimension && 
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        compress_type = 'compress-frame';
        break;
    }
  
    this.vhImage
      .getImageFromDesktop_Autoweb(file, 'images/design/objects', {
        compress_type: compress_type,
        resolution: resolution,
      })
      .then((res: any) => {
        if (res.vcode != 0) {
          this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${res.msg}`);
          return;
        } else {
          this.functionService.createMessage('success', 'tai_anh_thanh_cong');
        }
  
        if (this.isSharedImg) {
          this.functionService.devices.forEach((device) => {
            this.itemEdit[device.value + '_value'].push(res.data);
          });
        } else {
          this.itemEdit[this.device + '_value'].push(res.data);
        }

        this.updateDataImgs();
  
        // this.updateData(this.dataRow);
      });
  }

  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matDialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.isSharedImg) {
          this.functionService.devices.forEach((device) => {
            this.itemEdit[device.value + '_value'].push(data.href);
          });
        } else {
          this.itemEdit[this.device + '_value'].push(data.href);
        }

        this.updateDataImgs();

        // this.updateData(this.dataRow);
      }
      this.path = data.path;
    });
  }

  /**
   * Hàm xử lý lấy url ảnh từ các nguồn khác
   */
  handleChangeUrlImage(e) {
    e?.stopPropagation();
    if (!this.newUrlImage) {
      this.functionService.createMessage('error', 'vui_long_nhap_link_anh');
      return;
    }

    if (this.isSharedImg) {
      this.functionService.devices.forEach((device) => {
        this.itemEdit[device.value + '_value'].push(this.newUrlImage);
      });
    } else {
      this.itemEdit[this.device + '_value'].push(this.newUrlImage);
    }

    this.newUrlImage = '';
    // this.updateData(this.dataRow);
    this.updateDataImgs();
    this.closePopover();
  }

  /**
   * Hàm đóng popover của input link ảnh
   */
  closePopover(e?) {
    e?.stopPropagation();
    this.toggleInputLinkImg = false;
  }

  /**
   * Hàm kiểm tra link trong danh sách ảnh có id_subproject hay không
   * - Nếu chỉ một item trong danh sách không có id_subproject hoặc nếu imgItem = null thì return false
   * (Để không cần phải thực hiện chuyển lên server)
   * - Còn lại nếu tất cả item trong danh sách đều có id_subproject thì return true
   */
  hasSomeImgNotIncludeIdSubproject(): boolean {
    const images = this.itemEdit[this.device + '_value'] || [];
    return images.some((imgItem) => {
      if (!imgItem) return false;
      return !imgItem.includes(this.id_subproject);
    });
  }

  /**
   * Hàm mở popup kho ảnh dùng chung
   */
  openDialogChooseImage() {
    const dialogRef = this.matDialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.isSharedImg) {
          this.functionService.devices.forEach((device) => {
            this.itemEdit[device.value + '_value'].push(result);
          });
        } else {
          this.itemEdit[this.device + '_value'].push(result);
        }

        this.updateDataImgs();
        // this.updateData(this.dataRow);
        this.isShowConfirmPopup = true;
      }
    });
  }

  /**
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình thay đổi
   * */
  async handleOkConfirm() {
    this.isConfirmLoading = true;

    let compress_type = this.compressType;

    let resolution = {};
    switch (this.compressType) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.dimension[this.device];
        if (
          dimension && 
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        compress_type = 'compress-frame';
        break;
    }
    if (!this.itemEdit?.[this.device + '_value']) return;

    const promises = this.itemEdit[this.device + '_value'].map(
      (imageUrl, index) => {
        if (imageUrl.includes(this.id_subproject)) {
          return Promise.resolve(); // Bỏ qua ảnh đã chứa id_subproject
        }
        return this.vhImage
          .getImageFromURL_Autoweb(imageUrl, 'images/design/objects', {
            compress_type,
            resolution,
          })
          .then((rsp: any) => {
            if (rsp.vcode === 0) {
              if (this.isSharedImg) {
                this.functionService.devices.forEach((device) => {
                  this.itemEdit[device.value + '_value'][index] = rsp.data;
                });
              } else {
                this.itemEdit[this.device + '_value'][index] = rsp.data;
              }
              this.updateDataImgs();
              // this.updateData(this.dataRow);
              this.functionService.createMessage('success', 'tai_anh_thanh_cong');
            } else {
              this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${rsp.msg}`);
            }
          })
          .catch((error: any) => {
            const errMsg = error?.message || '';
            if (errMsg.includes('413')) {
              this.functionService.createMessage(
                'error',
                this.languageService.translate(
                  'file_anh_qua_lon_vui_long_chon_file_anh_co_dung_luong_nho_hon'
                ) + ' 1Mb'
              );
            } else if (
              errMsg.includes('403') ||
              errMsg.includes('CORS') ||
              errMsg.includes('Failed to fetch') ||
              errMsg.includes('ERR') // generic fail
            ) {
              this.functionService.createMessage(
                'error',
                this.languageService.translate(
                  'anh_bi_chan_hoac_khong_truy_cap_duoc'
                ) +
                  ': ' +
                  imageUrl
              );
              console.warn(
                this.languageService.translate(
                  'anh_bi_chan_hoac_khong_truy_cap_duoc'
                ) + ':',
                error
              );
              // Bỏ qua ảnh lỗi, không thêm vào danh sách
            } else {
              this.functionService.createMessage(
                'error',
                this.languageService.translate('xu_ly_anh_khong_thanh_cong') +
                  ': ' +
                  imageUrl
              );
              console.error(
                this.languageService.translate('xu_ly_anh_khong_thanh_cong') +
                  ': ',
                error
              );
            }
          });
      }
    );

    await Promise.all(promises);
    setTimeout(() => {
      this.isConfirmLoading = false;
      this.isShowConfirmPopup = false;
    }, 300);
  }

  /**
   * Lấy ra tên file và đuôi file
   * @param url Đường dẫn ảnh
   * @example const { fileName, fileExtension } = getFileInfo("https://115.78.228.208:20350/autowebapp/67c1b593b1344364462b082b/images/design/objects/3-1-768x768%20(3).png");
   */
  getFileInfo(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const parts = decodedUrl.split('/');
  
    // Lấy tên file (phần cuối)
    const fullFileName = parts.pop() || '';
    const dotIndex = fullFileName.lastIndexOf('.');
  
    // Tìm và lấy phần giữa (ví dụ: "images/design/objects")
    const indexImages = parts.indexOf('images');
    const folderPath =
      indexImages !== -1 ? parts.slice(indexImages).join('/') : '';
  
    return {
      fullFileName, // ví dụ: "3-1-768x768 (3).png"
      fileName: fullFileName.substring(0, dotIndex), // "3-1-768x768 (3)"
      fileExtension: fullFileName.substring(dotIndex + 1), // "png"
      folderPath, // "images/design/objects"
    };
  }

  /**
   * Sao chép đường dẫn hình ảnh vào bộ nhớ tạm
   * @param url Đường dẫn ảnh
   */
  copyLinkImg(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(url)
        .then(() => {
          this.functionService.createMessage('success', 'da_sao_chep_vao_bo_nho_tam', 2000);
        })
        .catch(err => {
          this.functionService.createMessage('error', 'loi_khi_sao_chep', 2000);
          console.error('❌ Lỗi khi copy:', err);
        });
    }
  }

  /**
   * Hàm này để đóng dialogChooseAnimation
   */
  close() {
    // Đảm bảo khi ng dùng vừa paste rồi bấm tắt luôn không bấm ra ngoài để blur
    if (this.itemEdit.youtube_url?.trim() && this.identifyYoutubeType(this.itemEdit?.youtube_url) !== 'EMBED_LINK') {
      this.itemEdit.youtube_url = this.formatEmbedUrl(this.itemEdit.youtube_url);
    }

    this.modalRef.close(this.dataRow);
  }

  /**
   * remove link khi click vào nút x
   */
  removeLink(fieldName: string) {
    this.itemEdit[fieldName] = '';
  }

  getBlocksbyPage() {
    if(this.itemEdit.type_link == 'page_link' || this.itemEdit.type_link == 'navigation_link') {
      const link = this.itemEdit.link.replace(/^\/+/, '').split('/')[0]
      this.vhQueryAutoWeb.getPages_byFields({ link: { $eq: link } })
        .then((pages: any) => {
          if(pages.length > 0 ) {
            this.vhQueryAutoWeb.getBlocks_byIDpage(pages[0]._id)
              .then((res: any) => { 
                this.blocks_of_page = res;
              })
          }
        })
    }
  }

  /**
   * Hàm kiểm tra giá trị truyền vào
   * @param { mailto, tel }
   * @returns boolean
   */
  isValidValue({ mailto, tel }: { mailto?: string; tel?: string } = {}): boolean {
    const patterns: any = {
      // mailto: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      mailto: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/i,
      // tel: /^((0|\+84)(3[2-9]|5[2689]|7[06-9]|8[1-689]|9[0-46-9])[0-9]{7}|(1800|1900)[0-9]{4})$/,
    };
  
    if (mailto) return patterns.mailto.test(mailto);
    // if (tel) return patterns.tel.test(tel);
    if (tel) return true;
  
    return true;
  }

  @HostListener('wheel', ['$event'])
  onMouseWheel(event: WheelEvent) {
    const container = this.scrollList.nativeElement;

    // Kiểm tra xem chuột có đang nằm trên vùng danh sách ảnh hay không
    // event.composedPath() trả về danh sách các thẻ mà sự kiện đi qua
    if (event.composedPath().includes(container)) {
      if (event.deltaY !== 0) {
        // Chặn cuộn dọc mặc định của trình duyệt
        event.preventDefault();
        
        // Chuyển hướng lăn chuột dọc thành cuộn ngang
        container.scrollLeft += event.deltaY;
      }
    }
  }

  updateDataImgs() {
    this.dataImages = this.itemEdit[this.device + '_value'];
  }

  /**
   * Xử lý chuyển link youtube, iframe thành link nhúng
   * @param input
   */
  formatEmbedUrl(input: string): string {
    if (!input) return '';
    
    let videoId = '';
    const trimmedInput = input.trim();

    // 1. Nếu là code iframe, trích xuất thuộc tính src trước
    if (trimmedInput.includes('<iframe')) {
      const srcMatch = trimmedInput.match(/src=["']([^"']+)["']/i);
      if (srcMatch) {
        return this.formatEmbedUrl(srcMatch[1]); // Đệ quy để xử lý link trong src
      }
    }

    // 2. Các Regex để bắt Video ID từ các loại link khác nhau
    const patterns = [
      /youtube(?:-nocookie)?\.com\/watch\?v=([^&?/\s]+)/, // Link watch (full & nocookie)
      /youtu\.be\/([^&?/\s]+)/,                           // Link rút gọn
      /youtube(?:-nocookie)?\.com\/embed\/([^&?/\s]+)/,   // Link nhúng (full & nocookie)
    ];

    for (let pattern of patterns) {
      const match = trimmedInput.match(pattern);
      if (match && match[1]) {
        videoId = match[1];
        break;
      }
    }

    // Trả về link nhúng chuẩn nếu tìm thấy ID, ngược lại trả về input gốc hoặc chuỗi rỗng
    if (videoId) {
      return `https://www.youtube-nocookie.com/embed/${videoId}`
    } else {
      // Trường hợp link youtube chưa chuyển sang dạng nocookie thì chuyển
      if (trimmedInput && trimmedInput.includes("youtube.com/embed")) {
        return trimmedInput.replace("youtube.com", "youtube-nocookie.com")
      }
      return trimmedInput;
    }
  }

  onInputBlur(field) {
    const value = this.itemEdit.youtube_url;

    // trường hợp chỉ điền khoảng cách
    if (!value?.trim()) {
      this.itemEdit.youtube_url = '';
    }

    switch (field) {
      case 'youtube_url': 
        if (value.trim()) {
          const embedUrl = this.formatEmbedUrl(value);
          this.itemEdit.youtube_url = embedUrl;
        }
        break;
    }
  }

  /**
   * Hàm kiểm tra link youtube này thuộc loại nào
   * > Dùng cho trường hợp người dùng chưa blur ô nhập youtube_url mà 
   * > đã bấm thêm hoặc lưu làm cho link không chuyển thành link nhúng
   * @param input link youtube
   * @returns loại link `"EMBED_CODE" | "EMBED_LINK" | "VIDEO_LINK" | "UNKNOWN"`
   */
  identifyYoutubeType(input): "EMBED_CODE" | "EMBED_LINK" | "VIDEO_LINK" | "UNKNOWN" {
    if (!input) return "UNKNOWN";
    const trimmedInput = input.trim();

    // 1. Kiểm tra Code nhúng (iframe) - Hỗ trợ cả youtube.com và youtube-nocookie.com
    const iframeRegex = /<iframe.*src=["']https:\/\/www\.youtube(?:-nocookie)?\.com\/embed\/([^"']+)["'].*><\/iframe>/i;
    if (iframeRegex.test(trimmedInput)) {
      return "EMBED_CODE";
    }

    // 2. Kiểm tra Link nhúng (embed link) - Hỗ trợ cả youtube.com và youtube-nocookie.com
    const embedLinkRegex = /^https?:\/\/(www\.)?youtube(?:-nocookie)?\.com\/embed\/([\w-]+)(\?.*)?$/i;
    if (embedLinkRegex.test(trimmedInput)) {
      return "EMBED_LINK";
    }

    // 3. Kiểm tra Link video (watch link hoặc short link)
    // Bao gồm: youtube.com/watch, youtube-nocookie.com/watch và youtu.be/
    const videoLinkRegex = /^https?:\/\/((www\.)?youtube(?:-nocookie)?\.com\/watch\?v=|youtu\.be\/)([\w-]+)(&.*|\?.*)?$/i;
    if (videoLinkRegex.test(trimmedInput)) {
      return "VIDEO_LINK";
    }

    return "UNKNOWN";
  }
}
